import React, {useMemo} from "react";
import Pages from "../../../components/layout/Pages";
import {backendEndpoints} from "../../../libs/backendEndpoints";
import SignUpFields, {signUpInitialValues} from "../../partials/SignUpFields";
import BackendForm from "../../../components/forms/BackendForm";
import {adminRoutes} from "../../../utils/routes";
import {useNavigate} from "react-router";
import {Alert} from "fearless-common-ui";


export default function AdminUserAdd<Values extends object>() {
  const navigate = useNavigate()

  const initialValues = useMemo(() => ({
    email: '',
    ...signUpInitialValues.Account,
    ...signUpInitialValues.UsernamePassword,
    groups: [],
  } as Values), []);

  return (
    <Pages.Centred width="sm">
      <Pages.BackButton href={adminRoutes.users}>users</Pages.BackButton>
      <h1>Add user</h1>
      <BackendForm<Values, { id: number }>
        targetMethod="POST"
        enableReinitialize
        onSuccess={({ data }) => navigate(adminRoutes.user(data.id))}
        targetEndpoint={backendEndpoints.signUp}
        initialValues={initialValues}
      >
        <SignUpFields.UsernamePassword checkDuplicate />
        <br/>
        <SignUpFields.Account showEmail />
        <SignUpFields.InstituteFields />
        <Alert>The user will receive an email-confirmation mail.</Alert>
      </BackendForm>
    </Pages.Centred>
  );
}
